import { FileUploadConfiguration } from '../../configurations';

export interface FileUploadValidatorResult {
  isValid: boolean;
  errorMessages: string[];
}

const generateSupportedFileExtensionMessage = (extensions: string[]): string => `Select a file with one of these extensions: ${extensions.join(', ')}.`;

export const calculateBytesFromMB = (sizeInMB: number): number => sizeInMB * 1024 * 1024;

export const fileUploadValidator = (file: File, fileUploadConfiguration: FileUploadConfiguration): FileUploadValidatorResult => {
  if (file.type.length > 0 && !fileUploadConfiguration.supportedFileTypes.includes(file.type)) {
    return {
      isValid: false,
      errorMessages: [
        'Select a supported file type.',
      ],
    };
  }

  if (file.type.length === 0 && !fileUploadConfiguration.supportedFileExtensions.includes(file.name.substring(file.name.lastIndexOf('.')))) {
    return {
      isValid: false,
      errorMessages: [
        generateSupportedFileExtensionMessage(fileUploadConfiguration.supportedFileExtensions),
      ],
    };
  }

  if (file.size > calculateBytesFromMB(fileUploadConfiguration.maxFileSizeInMB)) {
    return {
      isValid: false,
      errorMessages: [
        `Select a file that is ${fileUploadConfiguration.maxFileSizeInMB} MB or smaller.`,
      ],
    };
  }

  return {
    isValid: true,
    errorMessages: [],
  };
};
